import React, { useEffect, useState } from "react";
import Multiselect from "multiselect-react-dropdown";

function MultiselectDropdown({
  options,
  selectedvals,
  setSelectedVals,
  isSingleSelect = false,
  placeholder,
  id,
  styles,
}) {
  const onSelect = (selectedvalues, selectedItem) => {
    setSelectedVals(selectedvalues);
  };

  const onRemove = (selectedvalues, removedItem) => {
    setSelectedVals(selectedvalues);
  };

  const prepareMultiselectPlaceholder = () => {
    setMultiselectPlaceHolder(
      !selectedvals || selectedvals.length === 0
        ? "Select team"
        : selectedvals.length === 1
        ? selectedvals[0].key
        : selectedvals.length + " Teams"
    );
  };

  useEffect(() => {
    prepareMultiselectPlaceholder();
  }, [selectedvals]);

  const [multiselectPlaceHolder, setMultiselectPlaceHolder] =
    useState(placeholder);

  return isSingleSelect ? (
    <Multiselect
      id={id}
      displayValue="key"
      options={options} // Ensure options is an array of objects
      selectedValues={selectedvals} // Initial selected values
      onSelect={onSelect} // Callback for select
      onRemove={onRemove} // Callback for remove
      singleSelect
      placeholder={placeholder}
      style={styles}
    />
  ) : (
    <Multiselect
      id={id}
      displayValue="key"
      options={options} // Ensure options is an array of objects
      selectedValues={selectedvals} // Initial selected values
      onSelect={onSelect} // Callback for select
      onRemove={onRemove} // Callback for remove
      hideSelectedList
      showCheckbox
      placeholder={multiselectPlaceHolder}
      style={styles}
    />
  );
}

export default MultiselectDropdown;
